import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ExploreGalleries() {
    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            {/* Content */}
            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                {/* Section begin */}
                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Galleries</h1>
                                    {/* <p>Anim pariatur cliche reprehenderit</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section aria-label="section" id="section-galleries">
                    <div className="container">
                        <div className='row'>
                            <div class="col-md-3 col-lg-6 mb30 item">
                                <div class="nft_gall">
                                    <div class="nft_wrap">
                                        <a href="/home-gallery"><img src="https://f8n-production.imgix.net/worlds/cnwapb5mt.png?auto=format%2Ccompress&q=70&cs=srgb&w=750&h=500&fit=crop&dpr=2&fnd_key=v1" class="lazy img-fluid" alt="" /></a>
                                    </div>

                                    <div className="nft__item_info exploregall">
                                        <a href="/home-gallery">
                                            <h3>ART LOVER</h3>
                                        </a>
                                    </div>
                                    <div class="InfoHeaderCard_rightCol__yeB5O InfoHeaderCard_desktopCol__sxGtz exploregall">
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>ARTISTS</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">1 000</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>COLLECTIONS</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">2</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>NFT AVAILABLE</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">40</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>TOTAL SALES</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">184</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-6 mb30 item">
                                <div class="nft_gall">
                                    <div class="nft_wrap">
                                        <a href="/gallery"><img src="https://f8n-production.imgix.net/worlds/po7tya6ba.jpg?auto=format%2Ccompress&q=70&cs=srgb&w=750&h=500&fit=crop&dpr=2&fnd_key=v1" class="lazy img-fluid" alt="" /></a>
                                    </div>

                                    <div className="nft__item_info exploregall">
                                        <a href="/gallery">
                                            <h3>TOKIO SOLID</h3>
                                        </a>
                                        
                                    </div>
                                    <div class="InfoHeaderCard_rightCol__yeB5O InfoHeaderCard_desktopCol__sxGtz exploregall">
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>ARTISTS</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">1 000</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>COLLECTIONS</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">2</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>NFT AVAILABLE</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">40</p>
                                        </div>
                                        <div class="InfoHeaderCard_infoCol__xWNiX">
                                            <p>TOTAL SALES</p>
                                            <p class="Text_h5__WHXEO Text_default__Np3OB Text_semiBold__Iq4Jb InfoHeaderCard_description__6eytm">184</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div id="gallery" className="row">
                            {[
                                "https://f8n-production.imgix.net/worlds/cgohsgq6z.png?auto=format%2Ccompress&q=70&cs=srgb&w=750&h=500&fit=crop&dpr=2&fnd_key=v1",
                                "https://f8n-production.imgix.net/worlds/nvfeufl0f.jpg?auto=format%2Ccompress&q=70&cs=srgb&w=750&h=500&fit=crop&dpr=2&fnd_key=v1",
                                "https://storage.googleapis.com/fellowship-2022/web-v3/artists/featured/fellowship-artists-banner-elman-mansimov.jpg",
                                "https://daily.xyz/_next/image?url=https%3A%2F%2Fstorage.googleapis.com%2Ffellowship-2022%2Fweb-v3%2Fartists%2Fsplash%2Ffellowship-artists-beth-frey.jpg&w=3840&q=75",
                                "https://daily.xyz/_next/image?url=https%3A%2F%2Fstorage.googleapis.com%2Ffellowship-2022%2Fweb-v3%2Fartists%2Fsplash%2Ffellowship-artists-katie-morris.jpg&w=3840&q=75",
                                "https://daily.xyz/_next/image?url=https%3A%2F%2Fstorage.googleapis.com%2Ffellowship-2022%2Fweb-v3%2Fartists%2Fsplash%2Ffellowship-artists-graphica.jpg&w=3840&q=75"
                            ].map((src, idx) => (
                                <div key={idx} className="col-md-4 mb30 item">
                                    <div className="de-image-hover rounded">
                                        <a href={src} className="image-popup">
                                            <span className="dih-title-wrap">
                                                <span className="dih-title">Gallery Title</span>
                                            </span>
                                            <span className="dih-overlay"></span>
                                            <img src={src} className="lazy img-fluid" alt="Gallery" />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                    </div>
                </section>
            </div>

            {/* Footer */}
            <Footer />


        </div>
    );
}

export default ExploreGalleries;